(() => {
  if (window.guardenMeasureGuideReady) return;
  window.guardenMeasureGuideReady = true;
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-guarden-guide-open]');
    const close = event.target.closest('[data-guarden-guide-close]');
    if (close) {
      close.closest('[data-guarden-guide]').close();
      return;
    }
    if (!open) return;
    const dialog = open.closest('.measurements').querySelector('[data-guarden-guide]');
    if (!dialog || dialog.open) return;
    const frame = dialog.querySelector('[data-guarden-guide-frame]');
    if (!frame.getAttribute('src')) frame.src = frame.dataset.src;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.addEventListener('close', () => {
      document.body.style.overflow = overflow;
      if (open.isConnected) open.focus({preventScroll:true});
    }, {once:true});
    dialog.showModal();
  });
})();
